import React from "react";
import { SvgIcon, SvgIconProps } from "module/common/component/display";
export function ThinArrowIcon (props: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...props} data-testid="ThinArrowIcon">
            
<path d="M1 11C0.447715 11 9.65645e-08 11.4477 0 12C-9.65645e-08 12.5523 0.447715 13 1 13L1 11ZM23.2071 12.7071C23.5976 12.3166 23.5976 11.6834 23.2071 11.2929L16.8431 4.92893C16.4526 4.53841 15.8195 4.53841 15.4289 4.92893C15.0384 5.31946 15.0384 5.95262 15.4289 6.34315L21.0858 12L15.4289 17.6569C15.0384 18.0474 15.0384 18.6805 15.4289 19.0711C15.8195 19.4616 16.4526 19.4616 16.8431 19.0711L23.2071 12.7071ZM1 13L22.5 13L22.5 11L1 11L1 13Z" />


        </SvgIcon>
    )
}
        